import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class AsGeoJson extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.asgeojson',
            group: 'Parsers',
            title: 'ST as GeoJSON',
            description: `
      This component generates a new column with the GeoJSON representation of geographies in another column.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'geo',
                type: WorkflowComponentParamType.Column,
                title: 'Column with geographies definition',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            }
        ]);
    }
    getInnerSql({ params, connection }) {
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
                *, ST_ASGEOJSON(${connection.processInputGeogColumn(params.geo)}) AS ${params.geo}_geojson
              FROM ${connection.quoteName(params.source)}`;
        }
        else {
            return dedent `SELECT *, ST_ASGEOJSON(${connection.processInputGeogColumn(params.geo)}) AS ${params.geo}_geojson
              FROM ${connection.quoteName(params.source)}`;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns, params }) {
        return addColumn(columns.source, {
            name: `${params.geo}_geojson`,
            type: ColumnDataType.String
        });
    }
}
export { AsGeoJson };
